module.exports = __webpack_public_path__ + "media/images/squadBet__teamPlaceholder-3f2c4680fcaa28b2d5f72b19ccbc5e15.png";